module.exports = __webpack_public_path__ + "img/certificate_template.15206599.jpg";